import { KebabCase } from 'type-fest';

export type IBettingPalette = {
    cPrimary: string;
    cPrimaryLight: string;
    cPrimaryDark: string;

    cSecondary: string;
    cSecondaryLight: string;
    cSecondaryDark: string;

    cBackground: string;
    cBackgroundLight: string;
    cBackgroundDark: string;
    cBackgroundInvert: string;

    cSurface: string;
    cSurfaceLight: string;
    cSurfaceDark: string;
    cSurfaceInvert: string;

    cTextPrimary: string;
    cTextPrimaryLight: string;
    cTextPrimaryDark: string;
    cTextPrimaryInvert: string;

    cTextSecondary: string;
    cTextSecondaryLight: string;

    cSuccess: string;
    cSuccessLight: string;
    cSuccessDark: string;

    cError: string;
    cErrorLight: string;
    cErrorDark: string;

    cAction: string;
    cActionHover: string;
    cActionActive: string;
};

export const DEFAULT_PALETTE: IBettingPalette = {
    cPrimary: '#ff9c00',
    cPrimaryLight: '#ffb43d',
    cPrimaryDark: '#e08900',

    cSecondary: '#076dea',
    cSecondaryLight: '#076dea',
    cSecondaryDark: '#076dea',

    cBackground: '#14171d',
    cBackgroundLight: '#191c24',
    cBackgroundDark: '#000',
    cBackgroundInvert: '#fff',

    cSurface: '#2a3040',
    cSurfaceLight: '#3a4768',
    cSurfaceDark: '#1d212a',
    cSurfaceInvert: '#f9f9fb',

    cTextPrimary: '#fff',
    cTextPrimaryLight: '#bebebe',
    cTextPrimaryDark: '#9b9b9b',
    cTextPrimaryInvert: '#0e1014',

    cTextSecondary: '#5d6473',
    cTextSecondaryLight: '#808aa6',

    cSuccess: '#5cae50',
    cSuccessLight: '#7dbf73',
    cSuccessDark: '#325e2b',

    cError: '#cf2c27',
    cErrorLight: '#dd4f4b',
    cErrorDark: '#701515',

    cAction: '#fff',
    cActionHover: '#bebebe',
    cActionActive: '#ff9c00',
};

export type PaletteCssProp = `--${KebabCase<keyof IBettingPalette>}`;
export type PaletteCssPropRgb = `${PaletteCssProp}-rgb`;

export type PaletteRgbVars = {
    [key in IBettingPalette as PaletteCssPropRgb]: `${number}, ${number}, ${number}`;
};

export type PaletteHexVars = {
    [key in IBettingPalette as PaletteCssProp]: string;
};

export interface PaletteCssVariables extends PaletteHexVars, PaletteRgbVars {}
